import init from '@/pages/base'
import App from './App.vue'

import Notifications from '@kyvg/vue3-notification'

init(App, '[data-buggyfit-notifications]', (app) => {
    app.use(Notifications);
});
